import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiClient} from 'src/app/infrastructure/http/api.client';
import {UserPromotion} from 'src/app/domain/model/user/user-promotion.model';
import UserPromotionStore from 'src/app/domain/store/user/user-promotion.store';
import {filter, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export default class UserPromotionApi {
  private readonly url = 'user/promotions';
  private fetchAllInFlight: Promise<void> | null = null;
  private hasRequested = false;
  private generation = 0;

  constructor(private http: ApiClient, private promotionStore: UserPromotionStore) {
  }

  public fetchAll(): Promise<void> {
    this.hasRequested = true;

    if (!this.fetchAllInFlight) {
      const request: Promise<void> = this.requestAll().finally(() => {
        if (this.fetchAllInFlight === request) {
          this.fetchAllInFlight = null;
        }
      });
      this.fetchAllInFlight = request;
    }

    return this.fetchAllInFlight;
  }

  public invalidate(): void {
    this.generation++;
    this.fetchAllInFlight = null;
    this.hasRequested = false;
  }

  public all(): Observable<UserPromotion[] | null> {
    return this.promotionStore.promotions$.pipe(
      tap(() => {
        if (!this.hasRequested) {
          this.fetchAll();
        }
      }),
      filter(stored => !!stored)
    );
  }

  public syncAll(): UserPromotion[] | null {
    return this.promotionStore.syncAll();
  }

  private async requestAll(): Promise<void> {
    const generation = this.generation;

    try {
      const promotions: UserPromotion[] = await this.http.get(this.url);

      if (generation !== this.generation) {
        return;
      }

      this.promotionStore.saveAll(Object.values(promotions));
    } catch (error) {
      if (generation === this.generation) {
        this.hasRequested = false;
      }

      throw error;
    }
  }
}
